import React from 'react';
import { Svg } from 'components/icons/Svg';

export const IconSelectArrow = props => (
  <Svg {...props}>
    <path d="M12 15l5-6H7l5 6z" fill="currentColor" />
  </Svg>
);
